const populationDict = {
  Small: 'Mała',
  Medium: 'Średnia',
  Large: 'Duża',
};

export { populationDict as default };
